import { Controller } from "stimulus";

// Reveals a spinner when a form is submitted, for actions slow enough that a broker would
// otherwise wonder whether the click registered. Rails' own `disable_with` already stops a second
// click, so this only has to show that something is happening.
//
// Attach to the form and give it a spinner target:
//   form_with ..., data: { controller: "button-spinner", action: "submit->button-spinner#show" }
//     <span class="hidden" data-button-spinner-target="spinner">…</span>
export default class extends Controller {
  static targets = ["spinner"]

  show() {
    if (this.hasSpinnerTarget) this.spinnerTarget.classList.remove("hidden")
  }
}
